import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { setKey, session } from "../store/actions";
import { connect } from "react-redux";
import DataGrid from './DataGrid';
import moment from 'moment';
import conditionService from '../services/condition';
import { swalDeleteForm, swalError, swalSmallForm, swalSuccess } from "../utils/swal";

function ManageConditions({
    session,
    setKey,
    ...props
}) {
    const { t } = useTranslation();
    const [keyword, setKeyword] = useState(``);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        reload();
    }, [keyword]);

    const reload = async () => {
        await conditionService.getAll(session.token, keyword)
            .then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }

                if (Array.isArray(result.data)) {
                    setRows(result.data);
                } else {
                    console.error("Invalid data received:", result.data);
                    setRows([]);
                }
            });
    }

    const _clms = [{
        headerName: t("col_title"),
        field: "title"
    }, {
        headerName: t("col_active"),
        field: "active",
        cellRenderer: p => p.value === true ? t("yes") : t("no")
    }, {
        headerName: t("col_options"),
        field: "_id",
        resizable: true,
        sortable: false,
        cellRenderer: params => {
            const optionsHtml = document.createElement('div');
            optionsHtml.innerHTML = `
                <div class="text-center">
                    <button type="button" class="btn btn-sm btn-outline-primary btn-grid-row btn-record-edit">${t("btn_edit")}</button>
                    <button type="button" class="btn btn-sm btn-outline-danger btn-grid-row btn-record-delete">${t("btn_delete")}</button>
                </div>`;

            const btnEdit = optionsHtml.querySelectorAll('.btn-record-edit')[0];
            const btnDelete = optionsHtml.querySelectorAll('.btn-record-delete')[0];

            btnEdit.addEventListener('click', () => handlePopup(params.node.data));
            btnDelete.addEventListener('click', () => handleDelete(params.node.data._id));
            return optionsHtml;
        }
    }];

    const handleDelete = id => {
        swalDeleteForm(async () => {
            await conditionService.delete(session.token, id)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        return;
                    }

                    swalSuccess(t("deleted_success", { name: t("col_condition") }));
                    reload();
                });
        });
    }

    const handlePopup = obj => {
        swalSmallForm(obj, `condition`, async (title, active) => {
            if (obj) {
                const data = {
                    conditionId: obj._id,
                    title,
                    active
                };
                await conditionService.update(session.token, data)
                    .then(result => {
                        if (result.error) {
                            swalError(result.error);
                            return;
                        }

                        swalSuccess(t("updated_success", { name: t("col_condition") }));
                        reload();
                    });
            } else {
                const data = {
                    title,
                    active,
                    date: moment().format()
                };
                await conditionService.create(session.token, data)
                    .then(result => {
                        if (result.error) {
                            swalError(result.error);
                            return;
                        }

                        swalSuccess(t("created_success", { name: t("col_condition") }));
                        reload();
                    });
            }
        });
    }

    const handleSubmit = e => {
        e.preventDefault();
        handlePopup(null);
    }

    return (
        <div className="container">
            <div className="row mt-10">
                <div className="col text-left">
                    <h3>{t("manage_conditions_title")}</h3>
                </div>
                <div className="col text-right">
                    <button className="btn btn-primary" onClick={handleSubmit}>{t("btn_create")}</button>
                </div>
            </div>
            <div className="row mt-10">
                <div className="col">
                    <input type="text" className="form-control" placeholder={t("search_placeholder")}
                        value={keyword} onChange={e => setKeyword(e.target.value)} />
                </div>
            </div>
            <div className="row mt-10">
                <div className="col">
                    <DataGrid
                        columnDefs={_clms}
                        rowData={rows}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageConditions);